(function () {
  // -----------------------------
  // Utilities
  // -----------------------------
  function retry(fn, { attempts = 20, delay = 200 } = {}) {
    let count = 0;

    function run() {
      if (fn() || count >= attempts) return;
      count++;
      setTimeout(run, delay);
    }

    run();
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // -----------------------------
  // AfterSell Style Injection
  // -----------------------------
  function initAfterSellStyles() {
    retry(() => {
      const el = document.querySelector('#aftersell-pdp-upsell');
      if (!el || !el.shadowRoot) return false;

      const root = el.shadowRoot;

      if (root.querySelector('#custom-upsell-style')) return true;

      const style = document.createElement('style');
      style.id = 'custom-upsell-style';

      style.textContent = `
        .pdp-widget .product-info {
          padding-bottom: 0 !important;
        }
        .pdp-widget .product-card-actions {
          align-items: center;
        }
        .pdp-widget .add-button {
          padding: 10px 16px !important;
          height: auto !important;
          width: auto;
        }
      `;

      root.appendChild(style);
      return true;
    }, { attempts: 50, delay: 100 });
  }

  // -----------------------------
  // Product Gallery Loader
  // -----------------------------
  function initGalleryFromUrl() {
    const params = new URLSearchParams(window.location.search);

    const mediaId = params.get('media_id');
    const mediaIndex = parseInt(params.get('media'), 10);
    const openModal = params.get('modal') !== 'false';

    const isValidIndex = !isNaN(mediaIndex) && mediaIndex >= 0;
    if (!mediaId && !isValidIndex) return;

    retry(selectSlide, { attempts: 15, delay: 200 });

    function selectSlide() {
      const sliderElement =
        document.querySelector('.product-slideshow') ||
        document.querySelector('.flickity-enabled') ||
        document.querySelector('.flickity-slider') ||
        document.querySelector('.product-main-slide')?.parentElement;

      if (!sliderElement || !window.Flickity) return false;

      const flkty = Flickity.data(sliderElement);
      if (!flkty || !flkty.cells?.length) return false;

      let targetIndex = null;

      if (mediaId) {
        const slide = [...document.querySelectorAll('.product-main-slide')]
          .find(el => el.getAttribute('data-media-id') === mediaId);

        if (slide) {
          targetIndex = parseInt(slide.getAttribute('data-index'), 10);
        }
      } else {
        targetIndex = mediaIndex;
      }

      if (typeof targetIndex !== 'number' || isNaN(targetIndex)) {
        targetIndex = flkty.cells.length - 1;
      }

      targetIndex = Math.max(0, Math.min(targetIndex, flkty.cells.length - 1));

      flkty.select(targetIndex, false, true);

      if (openModal) {
        const slide = document.querySelector(
          `.product-main-slide[data-index="${targetIndex}"]`
        );

        const trigger = slide?.querySelector('.product-video-trigger');

        if (trigger) {
          setTimeout(() => trigger.click(), 100);
        }
      }

      return true;
    }
  }

  // -----------------------------
  // Flickity Sub-pixel Fix
  // -----------------------------
  function initFlickityWidthSnap() {
    const el = document.querySelector('.page-content--product .product-slideshow');
    if (!el) return;

    function snapWidth() {
      el.style.width = 'auto';
      const w = Math.floor(el.getBoundingClientRect().width);
      el.style.width = w + 'px';
      const flkty = Flickity.data(el);
      if (flkty) flkty.resize();
    }

    retry(() => {
      const flkty = Flickity.data(el);
      if (!flkty) return false;
      snapWidth();
      return true;
    }, { attempts: 20, delay: 150 });

    window.addEventListener('resize', snapWidth);
  }

  // -----------------------------
  // Product Carousel Component
  // -----------------------------
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-carousel-track');
      this.prev = this.querySelector('.product-carousel-nav-button--prev');
      this.next = this.querySelector('.product-carousel-nav-button--next');

      if (!this.track) return;

      this.bindEvents();
      this.update();
    }

    bindEvents() {
      this.prev?.addEventListener('click', () => this.scroll(-1));
      this.next?.addEventListener('click', () => this.scroll(1));

      this.track.addEventListener('scroll', () => this.update());
      window.addEventListener('resize', () => this.update());
    }

    scroll(direction) {
      const item = this.querySelector('.product-carousel-item');
      const amount = item
        ? item.offsetWidth + 20
        : this.track.offsetWidth * 0.8;

      this.track.scrollBy({
        left: direction * amount,
        behavior: 'smooth'
      });
    }

    update() {
      const atStart = this.track.scrollLeft <= 1;
      const atEnd =
        this.track.scrollLeft + this.track.offsetWidth >=
        this.track.scrollWidth - 1;

      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;

      const wrapper = this.querySelector('.product-carousel-wrapper');
      if (wrapper) {
        wrapper.classList.toggle('has-scroll-left', !atStart);
        wrapper.classList.toggle('has-scroll-right', !atEnd);
      }
    }
  }

  if (!customElements.get('product-carousel')) {
    customElements.define('product-carousel', ProductCarousel);
  }

  // -----------------------------
  // Init
  // -----------------------------
  function init() {
    initAfterSellStyles();
    initGalleryFromUrl();
    initFlickityWidthSnap();
  }

  onReady(init);

  // Support Shopify dynamic sections
  document.addEventListener('shopify:section:load', init);

})();